import {
  IntroSection,
  IntroImage,
  IntroContent,
  IntroTitle,
  IntroText,
  FeedbackSection,
  FeedbackTitle,
  FeedbackList,
  FeedbackItem,
  FeedbackAvatar,
  FeedbackName,
  FeedbackText,
  FAQSection,
  FAQTitle,
  FAQList,
  FAQItem,
  FAQQuestion,
  FAQAnswer,
  ContactSection,
  ContactTitle,
  ContactInfo,
  ContactRow,
  ContactText
} from './LandingPage.styled';
import {
  RegisterFormWrapper,
  RegisterForm,
  RegisterInput,
  RegisterButton,
  RegisterTitle,
  RegisterDesc
} from './LandingPage.styled';
import React from 'react';
import {
  Wrapper,
  Hero,
  HeroTitle,
  HeroDesc,
  CTAButton,
  Section,
  Feature,
  FeatureIcon,
  FeatureTitle,
  FeatureDesc,
  Footer
} from './LandingPage.styled';
import { useNavigate } from 'react-router-dom';
import phongLeTanImg from './images/phong_le_tan.png';
import leNhatAnhImg from './images/le_nhat_anh.png';
import linhPhuongImg from './images/linh_phuong.png';
import anNhienImg from './images/an_nhien.png';
import nguyenNgocBichImg from './images/nguyen_ngoc_bich.png';


const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Wrapper>
      {/* Floating logo next to login button (top right) */}
      <div style={{
        position:'fixed',
        top:16,
        right:32,
        zIndex:101,
        display:'flex',
        alignItems:'center',
        gap:'12px'
      }}>
        <div style={{
          width:'150px',
          height:'75px',
          display:'flex',
          alignItems:'center',
          justifyContent:'center',
          filter:'drop-shadow(0 6px 20px rgba(0,123,255,0.15))',
          borderRadius:'14px',
          padding:'8px 12px',
          animation:'floatLogo 3s ease-in-out infinite',
          background:'none',
          pointerEvents:'none'
        }}>
          <img src="/kt-english-logo.png" alt="KT English Logo" style={{width:'100%',maxWidth:'110px',height:'auto',objectFit:'contain',background:'transparent',mixBlendMode:'multiply',userSelect:'none'}} />
        </div>
        <style>{`
          @keyframes floatLogo {
            0% { transform: translateY(0px) scale(1); }
            50% { transform: translateY(-10px) scale(1.02); }
            100% { transform: translateY(0px) scale(1); }
          }
        `}</style>
        <CTAButton
          style={{background:'linear-gradient(90deg, #007bff 0%, #00bfff 100%)',padding:'0.7rem 2rem',fontSize:'1.05rem'}}
          onClick={() => navigate('/login')}
        >
          Đăng Nhập
        </CTAButton>
      </div>
      <Hero>
        <HeroTitle style={{color:'#007bff'}}>KT ENGLISH</HeroTitle>
        <HeroDesc style={{color:'#007bff'}}>
          Học tiếng Anh vui nhộn, hiệu quả cho trẻ em với giáo trình chuẩn quốc tế, giáo viên tận tâm và hoạt động tương tác hấp dẫn.
        </HeroDesc>
        <CTAButton>Đăng ký ngay</CTAButton>
      </Hero>


      {/* Section: Form đăng ký nổi bật */}
      <RegisterFormWrapper style={{marginTop:'-340px',marginBottom:'32px'}}>
        <RegisterForm onSubmit={e => { e.preventDefault(); alert('Đăng ký thành công!'); }}>
          <RegisterTitle>Đăng ký nhận tư vấn miễn phí</RegisterTitle>
          <RegisterDesc>Nhập thông tin để được tư vấn lộ trình học phù hợp cho bé</RegisterDesc>
          <RegisterInput type="text" placeholder="Họ và tên phụ huynh" required />
          <RegisterInput type="tel" placeholder="Số điện thoại" required />
          <RegisterInput type="email" placeholder="Email (nếu có)" />
          <RegisterButton type="submit">Đăng ký ngay</RegisterButton>
        </RegisterForm>
      </RegisterFormWrapper>

      {/* Section: Block hình ảnh/giới thiệu */}
      <IntroSection>
        <IntroImage src={phongLeTanImg} alt="Giới thiệu Betia" />
        <IntroContent>
           <IntroTitle>Vì sao nên chọn KT English?</IntroTitle>
          <IntroText>
             KT English mang đến môi trường học tiếng Anh hiện đại, thân thiện và hiệu quả cho trẻ em. Chúng tôi kết hợp giáo trình quốc tế, giáo viên tận tâm và các hoạt động tương tác giúp trẻ phát triển toàn diện.
          </IntroText>
          <IntroText>
            - Lộ trình học cá nhân hóa, phù hợp từng độ tuổi.
            <br />- Phương pháp học qua trải nghiệm, trò chơi, dự án thực tế.
            <br />- Cơ sở vật chất hiện đại, lớp học nhỏ, chăm sóc sát sao.
          </IntroText>
        </IntroContent>
      </IntroSection>

      <Section>
        <Feature>
          <FeatureIcon>🎯</FeatureIcon>
          <FeatureTitle>Bài học tương tác</FeatureTitle>
          <FeatureDesc>Trẻ được học qua trò chơi, hình ảnh, âm thanh giúp ghi nhớ lâu và hứng thú hơn.</FeatureDesc>
        </Feature>
        <Feature>
          <FeatureIcon>👩‍🏫</FeatureIcon>
          <FeatureTitle>Giáo viên giàu kinh nghiệm</FeatureTitle>
          <FeatureDesc>Đội ngũ giáo viên chuyên môn cao, tận tâm đồng hành cùng từng học sinh.</FeatureDesc>
        </Feature>
        <Feature>
          <FeatureIcon>🎉</FeatureIcon>
          <FeatureTitle>Hoạt động ngoại khóa</FeatureTitle>
          <FeatureDesc>Nhiều hoạt động, sự kiện, cuộc thi giúp trẻ tự tin giao tiếp và phát triển toàn diện.</FeatureDesc>
        </Feature>
      </Section>
      {/* Section: Feedback/Học viên tiêu biểu */}
      <FeedbackSection>
        <FeedbackTitle>Học viên tiêu biểu</FeedbackTitle>
        <FeedbackList>
          <FeedbackItem>
            <FeedbackAvatar src={nguyenNgocBichImg} alt="Nguyễn Ngọc Bích" />
            <FeedbackName>Nguyễn Ngọc Bích</FeedbackName>
             <FeedbackText>"Con rất thích học ở KT English, thầy cô vui vẻ và con có nhiều bạn mới!"</FeedbackText>
          </FeedbackItem>
          <FeedbackItem>
            <FeedbackAvatar src={leNhatAnhImg} alt="Lê Nhật Anh" />
            <FeedbackName>Lê Nhật Anh</FeedbackName>
            <FeedbackText>"Các tiết học rất thú vị, con được chơi trò chơi và học tiếng Anh dễ hiểu hơn."</FeedbackText>
          </FeedbackItem>
          <FeedbackItem>
            <FeedbackAvatar src={linhPhuongImg} alt="Dương Linh Phương" />
            <FeedbackName>Dương Linh Phương</FeedbackName>
            <FeedbackText>"Con tự tin nói tiếng Anh hơn nhờ các hoạt động nhóm ở lớp!"</FeedbackText>
          </FeedbackItem>
          <FeedbackItem>
            <FeedbackAvatar src={anNhienImg} alt="An Nhiên" />
            <FeedbackName>An Nhiên</FeedbackName>
            <FeedbackText>"Con tự tin nói tiếng Anh hơn nhờ các hoạt động nhóm ở lớp!"</FeedbackText>
          </FeedbackItem>
        </FeedbackList>
      </FeedbackSection>

      {/* Section: FAQ */}
      <FAQSection>
        <FAQTitle>Câu hỏi thường gặp</FAQTitle>
        <FAQList>
          <FAQItem>
            <FAQQuestion>Trẻ chưa biết tiếng Anh có học được không?</FAQQuestion>
            <FAQAnswer>Chương trình của Betia phù hợp cho cả trẻ mới bắt đầu và đã có nền tảng tiếng Anh. Giáo viên sẽ kiểm tra trình độ và tư vấn lộ trình phù hợp cho từng bé.</FAQAnswer>
          </FAQItem>
          <FAQItem>
            <FAQQuestion>Lớp học có bao nhiêu học sinh?</FAQQuestion>
            <FAQAnswer>Mỗi lớp chỉ từ 8-12 học sinh để đảm bảo chất lượng giảng dạy và sự quan tâm sát sao từ giáo viên.</FAQAnswer>
          </FAQItem>
          <FAQItem>
            <FAQQuestion>Phụ huynh có được theo dõi tiến bộ của con không?</FAQQuestion>
            <FAQAnswer>Phụ huynh sẽ nhận được báo cáo định kỳ về tiến bộ của con và có thể trao đổi trực tiếp với giáo viên bất cứ lúc nào.</FAQAnswer>
          </FAQItem>
        </FAQList>
      </FAQSection>

      {/* Section: Contact */}
      <ContactSection>
  <ContactTitle>Liên hệ với KT English</ContactTitle>
        <ContactInfo>
          <ContactRow>
            <span role="img" aria-label="phone">📞</span>
            <ContactText>Hotline: <a href="tel:0918334306" style={{color:'#007bff',textDecoration:'none'}}>0918 334 306</a></ContactText>
          </ContactRow>
          <ContactRow>
            <span role="img" aria-label="zalo">💬</span>
            <ContactText>Zalo: <a href="https://zalo.me/0918334306" target="_blank" rel="noopener noreferrer" style={{color:'#007bff',textDecoration:'none'}}>0918 334 306</a></ContactText>
          </ContactRow>
          <ContactRow>
            <span role="img" aria-label="address">📍</span>
            <ContactText>Địa chỉ: số 116, Đường Dương Xá, Thiệu Dương, TP Thanh Hoá</ContactText>
          </ContactRow>
        </ContactInfo>
      </ContactSection>

      <Footer>
  &copy; {new Date().getFullYear()} KT English. All rights reserved.
      </Footer>
    </Wrapper>
  );
};

export default LandingPage;
